import { Country } from './types';

export const EU_COUNTRIES = [
    Country.Austria,
    Country.Belgium,
    Country.Bulgaria,
    Country.Croatia,
    Country.Cyprus,
    Country['Czech Republic'],
    Country.Denmark,
    Country.Estonia,
    Country.Finland,
    Country.France,
    Country.Germany,
    Country.Greece,
    Country.Hungary,
    Country.Ireland,
    Country.Italy,
    Country.Latvia,
    Country.Lithuania,
    Country.Luxembourg,
    Country.Malta,
    Country.Netherlands,
    Country.Poland,
    Country.Portugal,
    Country.Romania,
    Country['Slovak Republic'],
    Country.Slovenia,
    Country.Spain,
    Country.Sweden,
];
